import './App.scss';
import React from 'react';

import logo from './assets/img/logo.png';
import heroImg from './assets/img/hero.png';
import landingEllipseLeft from './assets/img/Ellipse30.png';
import landingEllipseRight from './assets/img/Ellipse38.png';
import newsEllipseLeft from './assets/img/Group113.png'
import blobLeft from './assets/img/Vector3.png';
import blobRight from './assets/img/Vector4.png';
import landingBg from './assets/img/first-bg.png'
import whyCircleLeft from './assets/img/Group134.png'
import whyCircleRight from './assets/img/Group133.png'
import bottomLeftBg from './assets/img/Group-1.png'
import bottomRightBg from './assets/img/Group.png'
import learnHero from './assets/img/bottom-hero.png'
import bottomHero from './assets/img/bottom-hero-2.png'
import storageImg from './assets/img/storage.png'
import insuranceImg from './assets/img/money.png'
import walletImg from './assets/img/wallet.png'
import coinbaseLogo from './assets/img/coinbase.png'
import arrowIcon from './assets/img/arrow-icon.png'
import bottomLeftEllipse from './assets/img/Ellipse44.png'
import bottomRightEllipse from './assets/img/bottom-bg.png'

var XMLParser = require('react-xml-parser');

function decodeHtmlCharCodes(str) { 
  return str.replace(/(&#(\d+);)/g, function(match, capture, charCode) {
    return String.fromCharCode(charCode);
  });
}

class App extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      feed: []
    }
  }

  componentDidMount() {
    fetch('https://ambcrypto.com/tag/coinbase/feed/', { crossDomain:true })
      .then(response => response.text())
      .then(str => new XMLParser().parseFromString(str, "text/xml"))
      .then(data => {
        const items = data.getElementsByTagName('item');
        const feed = items.map(item => ({
          title: decodeHtmlCharCodes(item.getElementsByTagName('title')[0].value),
          link: item.getElementsByTagName('link')[0].value,
          description: decodeHtmlCharCodes(item.getElementsByTagName('description')[0].value.split('/>')[1]),
          category: item.getElementsByTagName('category')[0].value.substring(0, item.getElementsByTagName('category')[0].value.length - 2),
          img: item.getElementsByTagName('description')[0].value.split('/>')[0].split(' ')[3].split('\"')[1]
        })).slice(0, 6)
        console.log(feed)
        this.setState({ feed: feed })
      })
  }

  render() {
    const { feed } = this.state

    return (
      <div className='app'>
        <div className='header'>
          <a href='https://ambcrypto.com'>
            <img src={logo} className='amb-logo' />
          </a>
        </div>
        <section className='landing-info'>
          <img src={landingBg} className='landing-bg' />
          <img src={landingEllipseLeft} className='landing-bg-left' />
          <img src={landingEllipseRight} className='landing-bg-right' />
          <div className='landing-content-holder'>
            <div className='text-container'>
              <span className='description-text'>Launched three years after the creation of bitcoin in 2009, <br/><span className='highlight'>Coinbase</span> is a cryptocurrency exchange that allows active traders to purchase, sell, or hold more than 100 virtual assets, including Bitcoin, Ethereum, and 100+ other cryptocurrencies.</span>
            </div>
            <img src={heroImg} className='landing-hero' />
          </div>
        </section>
        <section className='news-section'>
          <img src={blobLeft} className='left-blob' />
          <img src={blobRight} className='right-blob' />
          <img src={newsEllipseLeft} className='ellipse-left' />
          <div className='news-title-holder'>
            <div className='divider-line' />
            <span className='title'>Our News</span>
            <div className='divider-line' />
          </div>
          <ul className='news-feed'>
            {
              feed.map(news => (
                <a href={news.link} target='_blank'>
                  <li>
                    <img className='featured-img' src={news.img} />
                    <div className='img-overlay' />
                    {/* <span className='coin-name'>{news.category}</span> */}
                    <div className='text-container'>
                      {/* <span className='time-ago'>1day ago</span> */}
                      <span className='news-title'>{news.title}</span>
                      <span className='news-description'>{news.description}</span>
                      <button className='read-more-btn'>Read More</button>
                    </div>
                  </li>
                </a>
              ))
            }
          </ul>
          <a href='https://ambcrypto.com/tag/coinbase' target='_blank'><button className='view-more-btn' target='_blank'>View More</button></a>
        </section>
        <section className='why-section'>
          <img src={whyCircleLeft} className='why-circle-left' />
          <img src={whyCircleRight} className='why-circle-right' />
          <div className='news-title-holder'>
            <div className='divider-line' />
            <span className='title'>Why Choose Coinbase?</span>
            <div className='divider-line' />
          </div>
          <ul className='feature-list'>
            <li className='type-one'>
              <img src={storageImg} className='feature-icon' />
              <div className='text-holder'>
                <span className='title'>Secure Storage</span>
                <span className='description'>We store the vast majority of the digital assets in secure offline storage.</span>
              </div>
              <span className='number'>1.</span>
            </li>
            <li className='type-two'>
              <span className='number'>2.</span>
              <div className='text-holder'>
                <span className='title'>Insurance</span>
                <span className='description'>Coinbase maintains crypto-insurance and all USD cash balances are covered by FDIC insurance, up to a maximum of $250,000.</span>
              </div>
              <img src={insuranceImg} className='feature-icon' />
            </li>
            <li className='type-one'>
              <img src={walletImg} className='feature-icon' />
              <div className='text-holder'>
                <span className='title'>Account Minimum</span>
                <span className='description'>Start trading as low as $2.</span>
              </div>
              <span className='number'>3.</span>
            </li>
            <li className='type-two'>
              <span className='number'>4.</span>
              <div className='text-holder'>
                <span className='title'>Easy To Use</span>
                <span className='description'>Coinbase’s easy-to-use interface, educational tools, and strong security measures make it a great choice for anyone looking to begin investing in cryptocurrency.</span>
              </div>
              <img src={coinbaseLogo} className='feature-icon' />
            </li>
          </ul>
        </section>
        <section className='learn-section'>
          <img src={bottomLeftBg} className='learn-bg-left' />
          <img src={bottomRightBg} className='learn-bg-right' />
          <span className='learn-title'>Learn & Earn Crypto</span>
          <img src={learnHero} className='learn-hero' />
          <span className='description'>Learn about new crypto projects and get a bit of each crypto to try out for yourself.</span>
          <a href='https://www.coinbase.com/earn?utm_source=ambcrypto' target='_blank'><button className='learn-more-btn'>Learn Now</button></a>
        </section>
        <section className='work-section'>
          <img src={bottomLeftEllipse} className='bottom-left-ellipse' />
          <img src={bottomRightEllipse} className='bottom-right-ellipse' />
          <span className='learn-title'>Want To Work With Coinbase?</span>
          <div className='bottom-landing-holder'>
            <img src={bottomHero} className='bottom-hero' />
            <div className='text-container'>
              <span className='title'>Work With Coinbase</span>
              <span className='description'>We’re a team of smart, creative optimists — the kind of people who see opportunity where others see roadblocks. Ready to build with us?</span>
              <a href='https://www.coinbase.com/careers?utm_source=ambcrypto' target='_blank'><button className='learn-more-btn'>Learn Now</button></a>
            </div>
          </div>
        </section>
        <section className='footer'>
          <div className='footer-item'>
            <img src={logo} className='amb-logo' />
            <a href='https://www.ambcrypto.com'><button className='cta-btn lined'><img src={arrowIcon} />Back To Amb Crypto</button></a>
          </div>
          <div className='footer-item'>
            <img src={coinbaseLogo} className='amb-logo cb' />
            <a href='https://www.coinbase.com/signup?utm_source=ambcrypto'><button className='cta-btn'>Back To Coinbase<img src={arrowIcon} /></button></a>
          </div>
        </section>
      </div>
    )
  }
}

export default App;
